import React, { useState, useContext } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaUserCircle } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import { useSettings } from '../../context/SettingsContext';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const { settings, loading: settingsLoading } = useSettings();
  const showLogoSkeleton = settingsLoading && settings.siteName === 'Musician Portfolio';
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    closeMenu();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link
          to="/"
          className={`navbar-logo${showLogoSkeleton ? ' is-loading' : ''}`}
          onClick={closeMenu}
          aria-busy={showLogoSkeleton}
        >
          {showLogoSkeleton ? (
            <span className="navbar-logo-skeleton" aria-hidden="true" />
          ) : (
            settings.siteName
          )}
        </Link>

        <button
          className="navbar-toggle"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <NavLink 
              to="/" 
              className={({ isActive }) => 
                isActive ? 'navbar-link active' : 'navbar-link'
              }
              onClick={closeMenu}
            >
              Home
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink 
              to="/about" 
              className={({ isActive }) => 
                isActive ? 'navbar-link active' : 'navbar-link'
              }
              onClick={closeMenu}
            >
              About
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink 
              to="/gallery" 
              className={({ isActive }) => 
                isActive ? 'navbar-link active' : 'navbar-link'
              }
              onClick={closeMenu}
            >
              Gallery
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink 
              to="/documents" 
              className={({ isActive }) => 
                isActive ? 'navbar-link active' : 'navbar-link'
              }
              onClick={closeMenu}
            >
              Documents
            </NavLink>
          </li>
          {settings.enableBookings && (
            <li className="navbar-item">
              <NavLink 
                to="/bookings" 
                className={({ isActive }) => 
                  isActive ? 'navbar-link active' : 'navbar-link'
                }
                onClick={closeMenu}
              >
                Bookings
              </NavLink>
            </li>
          )}
          {settings.enableLessons && (
            <li className="navbar-item">
              <NavLink 
                to="/lessons" 
                className={({ isActive }) => 
                  isActive ? 'navbar-link active' : 'navbar-link'
                }
                onClick={closeMenu}
              >
                Lessons
              </NavLink>
            </li>
          )}
          <li className="navbar-item">
            <NavLink 
              to="/contact" 
              className={({ isActive }) => 
                isActive ? 'navbar-link active' : 'navbar-link'
              }
              onClick={closeMenu}
            >
              Contact
            </NavLink>
          </li>
          
          {isAuthenticated && (
            <>
              <li className="navbar-item">
                <NavLink 
                  to="/admin" 
                  className={({ isActive }) => 
                    isActive ? 'navbar-link active' : 'navbar-link'
                  }
                  onClick={closeMenu}
                >
                  <FaUserCircle /> {user?.name || 'Admin'}
                </NavLink>
              </li>
              <li className="navbar-item">
                <button 
                  className="navbar-link" 
                  onClick={handleLogout}
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  Logout
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 